<template>
  <Row>
    <Col span="24">
      <Row :gutter="25">
        <Col :sm="24" :md="24" :lg="24" :xl="24">
          <Card class="sum-card-box" :padding="0" style="border: 0px solid #efefef; background: #f5f5f5">
            <div class="header_box">
              <div class="header_br"></div>
              <div class="header_title">日历</div>
            </div>
            <!-- <dv-scroll-board :config="config" style="height:260px;padding-left: 20px;padding-right: 20px;" /> -->
            <Calendar style="height: 100%; width: 100%"></Calendar>
          </Card>
        </Col>
      </Row>
    </Col>
  </Row>
</template>
<script>
import Calendar from 'vue-calendar-component'
export default {
  name: 'news',
  components: {
    Calendar,
  },
  data() {
    return {
      date: new Date(),
      min: '2012-12-12',
      max: '2020-12-12',
      curProcessWorkNum: 0,
      config: {
        header: ['状态', '描述', '维修人'],
        data: [],
        rowNum: 5, //表格行数
        headerHeight: 35,
        oddRowBGC: 'rgba(128, 99, 198, 0.5)', //奇数行
        evenRowBGC: 'rgba(252, 171, 97, 0.5)', //偶数行
        index: true,
        columnWidth: [50],
        align: ['center'],
        // carousel: 'page',
      },
    }
  },

  created() {},
  mounted() {
    this.largeTotalProcessWork()
    //当前日期
  },
  methods: {
    largeTotalProcessWork() {
      let q = {}
      $utils.api.load('largeTotalProcessWork', q).then((res) => {
        if (res.data) {
          let cc = res.data || {}
          this.curProcessWorkNum = cc.curProcessWorkNum || 0
          this.list = cc.curProcessWorkList || []
          let arr = []
          this.list.map((item) => {
            let dd = []
            let name = ''
            if (item.state == 1) {
              name = '待处理'
            }
            if (item.state == 2) {
              name = '处理中'
            }
            dd.push(name)
            dd.push(item.descr)
            dd.push(item.maintainerName)
            // dd.push(item.createTime)
            arr.push(dd)
          })
          this.config = {
            header: ['状态', '描述', '维修人'],
            data: arr,
            rowNum: 5, //表格行数
            headerHeight: 35,
            oddRowBGC: 'rgba(128, 99, 198, 0.5)', //奇数行
            evenRowBGC: 'rgba(252, 171, 97, 0.5)', //偶数行
            index: true,
            columnWidth: [50],
            align: ['center', 'left', 'left', 'right'],
            // carousel: 'page',
          }
        }
      })
    },
    marker(e) {
      if (e.type === 'date') {
        if (e.day === 6 || e.day === 0) {
          return '<span class="flag" title="周末标记">*</span>'
        }
      } else if (e.type === 'month') {
        if (e.month === 10) {
          return '<span class="flag" title="国庆标记">*</span>'
        }
      }
    },
  },
}
</script>
<style lang="less" scoped>
//  .dv-scroll-board{
//     color:#333;
//     .rows{
//       .row-item{
//            .ceil{
//           color:#3c3f52;
//         }
//       }
//     }
//   }
::v-deep .wh_content_all {
  background: #fff !important;
}
::v-deep .wh_item_date:hover {
  background: rgb(102, 162, 255) !important;
  border-radius: 50%;
}
::v-deep .wh_content_item :hover {
  color: #fff !important;
}
::v-deep .wh_content_item {
  color: #333 !important;
}
::v-deep .wh_top_changge li {
  color: #333 !important;
}
::v-deep .wh_jiantou1 {
  border-top: 2px solid #333 !important;
  border-left: 2px solid #333 !important;
}
::v-deep .wh_jiantou2 {
  border-top: 2px solid #333 !important;
  border-right: 2px solid #333 !important;
}
::v-deep .wh_isToday {
  background: rgb(255, 54, 54) !important;
  color: #fff !important;
}
::v-deep .wh_chose_day {
  background: rgb(102, 162, 255) !important;
  color: #fff !important;
}
.sum-card-box {
  float: left;
  width: 100%;
  height: 375px;
  margin-top: 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
  background-color: #f9f9f9;
  transition: 0.2s all ease;
  position: relative;
  padding: 20px 24px 8px;
  .header_box {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }
  .header_br {
    width: 4px;
    height: 20px;
    background-color: rgb(228, 4, 19);
  }
  .header_title {
    font-family: SourceHanSansSC;
    font-weight: 700;
    font-size: 15px;
    color: rgb(16, 16, 16);
    font-style: normal;
    letter-spacing: 0px;
    text-decoration: none;
    margin-left: 10px;
  }
  .wrapp {
    display: flex;
    align-items: center;
    margin-top: 30px;
    .earch_box {
      width: 60%;
      height: 100%;
    }
  }
  .box {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .item {
      display: flex;
      align-items: center;
      justify-items: center;
      margin-left: 15px;
      margin-right: 10px;
      margin-top: 20px;
      .image {
        width: 15px;
        height: 15px;
        background: #ccc;
        border-radius: 15px;
        margin-right: 10px;
      }
      .left {
        display: flex;
        align-items: flex-start;
        justify-items: center;
        flex-direction: column;
      }
      .num {
        font-family: SourceHanSansSC;
        font-weight: 400;
        font-size: 13px;
        color: rgb(16, 16, 16);
        font-style: normal;
      }
      .title {
        font-family: SourceHanSansSC;
        font-weight: 400;
        font-size: 13px;
        color: rgb(16, 16, 16, 0.3);
        font-style: normal;
        margin-top: 10px;
      }
    }
  }
  .item3 {
    height: 0px;
    margin-bottom: 2px;
    width: 100%;
  }
  .item4 {
    border-top: 1px solid #e8e8e8;
    padding-top: 5px;
    margin-top: 8px;
    font-size: 14px;
    line-height: 22px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    span:last-child {
      margin-left: 8px;
      color: rgba(0, 0, 0, 0.85);
    }
  }
}
.dateBox {
  width: 300px;
  height: 300px;
  border: 1px solid #cccccc;
}
</style>
